import {
  BodyText,
  Card,
  Flex,
  Heading,
  Link,
} from '@utilitywarehouse/hearth-react';
import { ChevronRightSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import SmartMeterImage from '@utilitywarehouse/hearth-svg-assets/lib/spot-smart-meter-light.svg';
import { useEffect, useRef } from 'react';

import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupThankyouSmartMeterPromoDisplayedOnce } from '@tracking/trackingEvents';

import './styles.scss';

interface SmartMeterProps {
  link: string;
}

const SmartMeter = ({ link }: SmartMeterProps) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const isInView = useIsInView(titleRef);
  const trackSmartMeterPromoDisplayed =
    useTrackSignupThankyouSmartMeterPromoDisplayedOnce();
  const { trackingContexts } = useTrackingContext();

  useEffect(() => {
    if (isInView) {
      trackSmartMeterPromoDisplayed({}, { contexts: trackingContexts });
    }
  }, [isInView, trackSmartMeterPromoDisplayed, trackingContexts]);

  return (
    <Flex direction="column" spacing="xl">
      <Heading as="h2" size="lg">
        Maximise your savings
      </Heading>
      <Flex direction="column" spacing="2xl">
        <Card
          variant="subtle"
          colorScheme="energy"
          spacing="lg"
          alignItems="center"
          direction={{
            tablet: 'row',
            mobile: 'column',
          }}
        >
          <img
            className="thankYou__smart-meter-image"
            src={SmartMeterImage}
            alt="Smart meter"
          />
          <Flex
            direction="column"
            spacing="lg"
            justifyContent="between"
            alignItems={{ tablet: 'start', mobile: 'center' }}
            textAlign={{ tablet: 'left', mobile: 'center' }}
          >
            <Flex direction="column" spacing="sm">
              <Heading as="h3" ref={titleRef} size="sm">
                Upgrade to a smart meter for free
              </Heading>
              <BodyText>
                Don’t have a smart meter yet? Upgrade for free and forget about
                submitting meter readings.
              </BodyText>
            </Flex>
            <Link
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              hideOpenIcon
            >
              Book appointment
              <ChevronRightSmallIcon />
            </Link>
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
};

export { SmartMeter };
